import { DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import type { EditAsideWebBannerFromOrTo } from '@nodeTypeConfig/configTypes';
import { updateWebsiteConfigurationActionNew } from '@store/actions/documentActions';
import { nlBE } from 'date-fns/locale/nl-BE';
import { get } from 'lodash';
import { any } from 'prop-types';
import type React from 'react';
import { useDispatch } from 'react-redux';
import { useCurrentWebConfig } from '../../../hooks/UseCurrentWebConfig';
import { useEditHref } from '../../../hooks/UseEditHref';
import { useTypedSelector } from '../../../hooks/useTypedSelector';
import { convertDateToUTCISOString, datePickerDefaultOptions } from '../asideDatePicker/dateHelper';
import { selectIsBannerReadonly } from '../asideWebSimpleInput/asideWebSimpleInputSelectors';

const AsideWebDatePicker: React.FC<{
  config: EditAsideWebBannerFromOrTo;
  readonly: boolean;
}> = ({ config, readonly }) => {
  const dispatch = useDispatch();

  const editHref = useEditHref();

  const currentWebConfig = useCurrentWebConfig();
  const currentValue = get(currentWebConfig, config.property, '');
  const currentDate = currentValue ? new Date(currentValue) : null;

  const componentReadOnly = useTypedSelector(
    (state) => readonly || selectIsBannerReadonly(state, config),
  );

  const change = (value: Date | null) => {
    dispatch(
      updateWebsiteConfigurationActionNew(
        editHref,
        config.property,
        value ? convertDateToUTCISOString(value) : undefined,
      ),
    );
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={nlBE}>
      <label className="control-label">{config.label}</label>
      <DatePicker
        format="dd/MM/yyyy"
        value={currentDate}
        onChange={change}
        readOnly={componentReadOnly}
        slotProps={datePickerDefaultOptions}
      />
    </LocalizationProvider>
  );
};

AsideWebDatePicker.displayName = 'AsideWebDatePicker';

export default AsideWebDatePicker;

AsideWebDatePicker.propTypes = {
  config: any,
  readonly: any,
};
